var jade = require("/data/node/puzzle-author/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"title\">通知管理</div><hr><p>通知管理功能正在准备</p>");;return buf.join("");
}